import React, {useState} from 'react';
import clsx from "clsx";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import {Avatar, Badge, Paper} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import SmsTwoToneIcon from '@mui/icons-material/SmsTwoTone';
import LocalHospitalTwoToneIcon from '@mui/icons-material/LocalHospitalTwoTone';
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';
import Divider from "@mui/material/Divider";
import BathtubTwoToneIcon from "@mui/icons-material/BathtubTwoTone";
import LabelTwoToneIcon from "@mui/icons-material/LabelTwoTone";
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import DeveloperBoardTwoToneIcon from '@mui/icons-material/DeveloperBoardTwoTone';
import SpeakerNotesOffTwoToneIcon from '@mui/icons-material/SpeakerNotesOffTwoTone';
import {brown, green, grey, orange, purple, red, teal} from "@mui/material/colors";
import Typography from "@mui/material/Typography";

const TamponiDrawer = ({
	                       selectMenuItem,
	                       stato,
	                       setFilters,
	                       filters,
	                       rapidi = false,
	                       testTipoDesc,
	                       setTestTipoDesc,
	                       info,
	                       irreperibili,
	                       setIrreperibili
                       }) => {
	const classes = BaseStyle();
	
	const [open, setOpen] = useState(true);
	
	const handleDrawerOpenClose = () => {
		setOpen(!open);
	};
	
	return (
        <React.Fragment>
            <Paper
				className={clsx(classes.drawer, classes.roundBorder, open ? classes.openDrawer : classes.closedDrawer)}>
				<div style={{display: "flex", justifyContent: "center"}}>
					<Tooltip title={open ? "Comprimi menù" : "Espandi menù"}>
						<IconButton onClick={handleDrawerOpenClose} size="large">
							{!open ? <ChevronRightIcon/> : <ChevronLeftIcon/>}
						</IconButton>
					</Tooltip>
				</div>
				{
					rapidi &&
					<React.Fragment>
						<List>
							<ListItem button className={classes.roundBorder}
							          selected={testTipoDesc === "Tampone Rapido a lettura facilitata (91.13.S)"}
							          onClick={() => setTestTipoDesc("Tampone Rapido a lettura facilitata (91.13.S)")}>
								<ListItemIcon>
									<DeveloperBoardTwoToneIcon/>
								</ListItemIcon>
								<ListItemText style={{width: 190, whiteSpace: "pre-wrap"}}
								              primary={"Tampone Rapido a lettura facilitata (91.13.S)"}/>
							</ListItem>
							<ListItem button className={classes.roundBorder}
							          selected={testTipoDesc === "Tampone Rapido a lettura manuale (91.13.M)"}
							          onClick={() => setTestTipoDesc("Tampone Rapido a lettura manuale (91.13.M)")}>
								<ListItemIcon>
									<DescriptionTwoToneIcon/>
								</ListItemIcon>
								<ListItemText style={{width: 190, whiteSpace: "pre-wrap"}}
								              primary={"Tampone Rapido a lettura manuale (91.13.M)"}/>
							</ListItem>
						</List>
						<Divider/>
					</React.Fragment>
				}
				<List>
					<ListItem button className={classes.roundBorder} selected={stato === "Da gestire"}
					          onClick={() => selectMenuItem("Da gestire")}>
						<ListItemIcon>
							<Badge badgeContent={info?.["Da gestire"]} color={"primary"} max={9999} showZero>
								<LocalHospitalTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Da gestire"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "Preso in carico"}
					          onClick={() => selectMenuItem("Preso in carico")}>
						<ListItemIcon>
							<Badge badgeContent={info?.["Presi in carico"]} color={"primary"} max={9999} showZero>
								<SmsTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Presi in carico"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "Gestito"}
					          onClick={() => selectMenuItem("Gestito")}>
						<ListItemIcon>
							<Badge badgeContent={info?.["Gestiti"]} color={"primary"} max={999999} showZero>
								<HomeTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Gestiti"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "Irreperibile"}
					          onClick={() => selectMenuItem("Irreperibile")}>
						<ListItemIcon>
							<Badge badgeContent={info?.["Irreperibile"]} color={"primary"} max={9999} showZero>
								<SpeakerNotesOffTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Irreperibili"}/>
					</ListItem>
				</List>
				<Divider/>
				<List>
					<ListItem button className={classes.roundBorder} selected={stato === "In gestione"}
					          onClick={() => selectMenuItem("In gestione")}>
						<ListItemIcon>
							<Badge badgeContent={info?.["In gestione"]} color={"primary"} max={9999} showZero>
								<BathtubTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"In gestione"}/>
					</ListItem>
				</List>
				<Divider/>
				<List subheader={<Typography color={"textSecondary"} style={{padding: 4, paddingLeft: 10}}>
					Comunicazioni
				</Typography>}>
					<ListItem button className={classes.roundBorder} selected={irreperibili === "SMS + MAIL"}
					          onClick={() => setIrreperibili(irreperibili === "SMS + MAIL" ? "" : "SMS + MAIL")}>
						<ListItemIcon>
							<Avatar style={{width: 20, height: 20, fontSize: 14, backgroundColor: grey[800]}}>
								<b>A</b>
							</Avatar>
						</ListItemIcon>
						<ListItemText primary={"SMS + MAIL"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={irreperibili === "SMS"}
					          onClick={() => setIrreperibili(irreperibili === "SMS" ? "" : "SMS")}>
						<ListItemIcon>
							<Avatar style={{width: 20, height: 20, fontSize: 14, backgroundColor: grey[800]}}>
								<b>S</b>
							</Avatar>
						</ListItemIcon>
						<ListItemText primary={"SMS"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={irreperibili === "MAIL"}
					          onClick={() => setIrreperibili(irreperibili === "MAIL" ? "" : "MAIL")}>
						<ListItemIcon>
							<Avatar style={{width: 20, height: 20, fontSize: 14, backgroundColor: grey[800]}}>
								<b>M</b>
							</Avatar>
						</ListItemIcon>
						<ListItemText primary={"MAIL"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={irreperibili === "NESSUNA"}
					          onClick={() => setIrreperibili(irreperibili === "NESSUNA" ? "" : "NESSUNA")}>
						<ListItemIcon>
							<Avatar style={{width: 20, height: 20, fontSize: 14, backgroundColor: grey[800]}}>
								<b>N</b>
							</Avatar>
						</ListItemIcon>
						<ListItemText primary={"NESSUNA"}/>
					</ListItem>
				
				</List>
				<Divider/>
				<List>
					<ListItem button className={classes.roundBorder}
					          onClick={() => setFilters(filters === "NEGATIVO" ? "" : "NEGATIVO")}>
						<ListItemIcon>
							<Badge badgeContent={info?.["Negativi"]} color={"primary"} max={9999} showZero>
								<LabelTwoToneIcon style={filters.includes("NEGATIVO") ? {color: green[500]} : {}}/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"NEGATIVO"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder}
					          onClick={() => setFilters(filters === "POSITIVO" ? "" : "POSITIVO")}>
						<ListItemIcon>
							<Badge badgeContent={info?.["Positivi"]} color={"primary"} max={9999} showZero>
								<LabelTwoToneIcon style={filters.includes("POSITIVO") ? {color: red[500]} : {}}/>
							</Badge>
						</ListItemIcon>
						
						<ListItemText primary={"POSITIVO"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder}
					          onClick={() => setFilters(filters === "N/D" ? "" : "N/D")}>
						<ListItemIcon>
							<Badge badgeContent={info?.["Non dichiarati"]} color={"primary"} max={9999} showZero>
								<LabelTwoToneIcon style={filters.includes("N/D") ? {color: orange[500]} : {}}/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"NON DICHIARATO"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder}
					          onClick={() => setFilters(filters === "INDETERMINATO" ? "" : "INDETERMINATO")}>
						<ListItemIcon>
							<Badge badgeContent={info?.["Indeterminati"]} color={"primary"} max={9999} showZero>
								<LabelTwoToneIcon style={filters.includes("INDETERMINATO") ? {color: teal[500]} : {}}/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"INDETERMINATO"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder}
					          onClick={() => setFilters(filters === "NON PERVENUTO" ? "" : "NON PERVENUTO")}>
						<ListItemIcon>
							<Badge badgeContent={info?.["Non pervenuti"]} color={"primary"} max={9999} showZero>
								<LabelTwoToneIcon style={filters.includes("NON PERVENUTO") ? {color: brown[500]} : {}}/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"NON PERVENUTO"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder}
					          onClick={() => setFilters(filters === "NON VALIDO" ? "" : "NON VALIDO")}>
						<ListItemIcon>
							<Badge badgeContent={info?.["Non validi"]} color={"primary"} max={9999} showZero>
								<LabelTwoToneIcon style={filters.includes("NON VALIDO") ? {color: purple[500]} : {}}/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"NON VALIDO"}/>
					</ListItem>
				</List>
			</Paper>
        </React.Fragment>
    );
};

export default React.memo(TamponiDrawer)
